import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IMembershipVehicleList } from "../../../Pages/MembershipVehicle/IMembershipVehicle";

interface IUpdate extends IReduxState<IMembershipVehicleList> {
  updateableDate?: IMembershipVehicleList;
}

export const UpdateMembershipVehicleSlicer = createSlice({
  name: "UpdateMembershipVehicle",
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateMembershipVehicle: (state, _) => {
      state.isLoading = true;
    },
    successUpdateMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    MembershipVehiclesUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateMembershipVehicleState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateMembershipVehicle,
  failureUpdateMembershipVehicle,
  successUpdateMembershipVehicle,
  MembershipVehiclesUpdateableData,
  clearUpdateMembershipVehicleState,
  clearUpdateableData,
} = UpdateMembershipVehicleSlicer.actions;

export default UpdateMembershipVehicleSlicer.reducer;
